<template>
  <v-sheet class="pa-4">
    <v-progress-circular v-if="loading_referees" indeterminate size="64"></v-progress-circular>

    <div class="d-flex flex-wrap">
      <v-card
        v-for="referee in referees"
        :key="referee.id"
        class="ma-2"
        width="300"
      >
        <v-card-text>
          <div v-if="editingId === referee.id">
            <v-text-field
              v-model="editName"
              label="Referee Name"
              dense
              @keyup.enter="saveEdit(referee)"
              @keyup.esc="cancelEdit"
            ></v-text-field>
          </div>
          <div v-else>
            <div class="text-h6">{{ referee.name }}</div>
            <div class="text-subtitle-2 text-grey">ID: {{ referee.external_resource_id || 'N/A' }}</div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-btn
            v-if="editingId === referee.id"
            text
            color="primary"
            @click="saveEdit(referee)"
          >
            Save
          </v-btn>
          <v-btn
            v-if="editingId === referee.id"
            text
            @click="cancelEdit"
          >
            Cancel
          </v-btn>
          <v-btn
            v-if="editingId !== referee.id"
            text
            color="primary"
            @click="startEdit(referee)"
          >
            Edit
          </v-btn>
          <v-btn
            text
            color="error"
            @click="confirmDelete(referee)"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>

      <!-- Add New Referee Card -->
      <v-card
        class="ma-2"
        width="300"
        outlined
      >
        <v-card-text>
          <v-text-field
            v-model="newRefereeName"
            label="New Referee Name"
            dense
            @keyup.enter="addReferee"
          ></v-text-field>
          <v-text-field
            v-model="newRefereeId"
            label="External Resource ID (Optional)"
            dense
            type="number"
            @keyup.enter="addReferee"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="primary"
            @click="addReferee"
            :disabled="!newRefereeName"
          >
            Add Referee
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <v-dialog v-model="deleteDialog" max-width="300">
      <v-card>
        <v-card-title>Delete Referee</v-card-title>
        <v-card-text>
          Are you sure you want to delete this referee?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn
            color="error"
            text
            @click="deleteRefereeConfirmed"
          >
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="3000"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'RefereeList',

  data() {
    return {
      editingId: null,
      editName: '',
      newRefereeName: '',
      newRefereeId: null,
      deleteDialog: false,
      refereeToDelete: null,
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      }
    };
  },

  created() {
    this.initReferees(this.$route.params.league_id);
  },

  methods: {
    ...mapActions('admin', [
      'initReferees',
      'updateReferee',
      'deleteReferee',
      'createReferee'
    ]),

    startEdit(referee) {
      this.editingId = referee.id;
      this.editName = referee.name;
    },

    cancelEdit() {
      this.editingId = null;
      this.editName = '';
    },

    async saveEdit(referee) {
      try {
        await this.updateReferee({
          id: referee.id,
          name: this.editName
        });
        this.showSnackbar('Referee updated successfully', 'success');
        this.cancelEdit();
      } catch (error) {
        this.showSnackbar('Failed to update referee', 'error');
      }
    },

    async addReferee() {
      if (!this.newRefereeName) return;

      try {
        await this.createReferee({
          league_id: this.$route.params.league_id,
          name: this.newRefereeName,
          external_resource_id: this.newRefereeId || null
        });
        this.showSnackbar('Referee added successfully', 'success');
        this.newRefereeName = '';
        this.newRefereeId = null;
      } catch (error) {
        this.showSnackbar('Failed to add referee', 'error');
      }
    },

    confirmDelete(referee) {
      this.refereeToDelete = referee;
      this.deleteDialog = true;
    },

    async deleteRefereeConfirmed() {
      try {
        await this.deleteReferee(this.refereeToDelete.id);
        this.showSnackbar('Referee deleted successfully', 'success');
      } catch (error) {
        this.showSnackbar('Failed to delete referee', 'error');
      }
      this.deleteDialog = false;
      this.refereeToDelete = null;
    },

    showSnackbar(text, color) {
      this.snackbar = {
        show: true,
        text,
        color
      };
    }
  },

  computed: {
    ...mapGetters('admin', [
      'referees',
      'loading_referees'
    ])
  }
};
</script>